module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgement"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_vm._v("Introduction: A Brief History of Bristol")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/part01"
    }
  }, [_vm._v("Part I. From the Past: Haunts from Early Bristol")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#pt1-h1"
    }
  }, [_vm._v("Bristol’s First Known Ghost")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#pt1-h2"
    }
  }, [_vm._v("The Ghost of Doug Thomas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#pt1-h3"
    }
  }, [_vm._v("Reverend James King Rides Again")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II. Ghosts of the Civil War")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#pt2-h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sad Soldier at Cedar Hill")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#pt2-h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Georgia Drummer Boy in East Hill Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#pt2-h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ghost that Wasn’t")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III. Bristol Terrors and Tragedies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part03#pt3-h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Singing Ghost at Old St. Luke’s Hospital")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part03#pt3-h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Headless, Hungry Hobo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part03#pt3-h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Haunted Pillow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part03#pt3-h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ghosts in the Storm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part03#pt3-h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lovers in Life, Lovers in Death")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part03#pt3-h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Haunted Georgia Avenue Bridge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part03#pt3-h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Distraught Ghost")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part03#pt3-h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ghosts in the Knobs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part03#pt3-h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bristol’s Strangest Ghost")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part IV. Messages from the Grave")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part04#pt4-h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Answering Service")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part04#pt4-h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Note from Beyond")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part04#pt4-h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ghostly Greeter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part04#pt4-h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I’ll Be Home Tomorrow Night")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part V. Haunted Homes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part05#pt5-h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Quail Run Ghost")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part05#pt5-h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hymn-Singing Ghost of King Mansion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part05#pt5-h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Smoking Chimney Ghost")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part05#pt5-h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Terror in the Bathroom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/part06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part VI. Prophets, Warnings and Witches")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part06#pt6-h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Warning Light in East Hill Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part06#pt6-h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strange Powers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part06#pt6-h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pocahontas Hale Walks Again")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part06#pt6-h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bristol’s Oldest Psychic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part06#pt6-h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Voodoo Woman Appears Again")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part06#pt6-h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The White Flag Flying")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/part07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part VII. Humorous “Haints” and the Lively Dead")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part07#pt7-h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ghost Hog in the Smokehouse, or No Bacon for Breakfast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part07#pt7-h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ghost Rattlesnake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part07#pt7-h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sleeping with a Ghost, or More than She Bargained For")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part07#pt7-h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chased by a Dead Man")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part07#pt7-h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ghost in the Outhouse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part07#pt7-h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Man Who Stopped his Own Funeral")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part07#pt7-h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Howdy Ghost of Vinegar Hill")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part07#pt7-h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Methodist Mission Ghost")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0